import React, { Component } from 'react';
import Xarrow from 'react-xarrows';
import {
  Accordion,
  Grid,
  Icon,
  Image,
  Header,
} from 'semantic-ui-react';
import sbahn from '../images/publicTransportInformation/sbahn.svg';
import ubahn from '../images/publicTransportInformation/ubahn.svg';
import bus from '../images/publicTransportInformation/bus.svg';
import tram from '../images/publicTransportInformation/tram.svg';
import changeStop from '../images/publicTransportInformation/changeStop.svg';
import intermediateStop from '../images/publicTransportInformation/intermediateStop.svg';
//const colors = require('../data/colors.json');

class PublicTransportInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stopsActive: false,
    }
  }

  getTerminus = () => {
    return this.props.section.transport.headsign;
  }

  getHeadsign = () => {
    return this.props.section.transport.name;
  }

  getPointOfEntry = () => {
    return this.props.section.departure.place.name;
  }

  getExitPoint = () => {
    return this.props.section.arrival.place.name;
  }

  getType = () => {
    return this.props.section.transport.category;
  }

  getDropdownIcon = () => {
    if (this.state.stopsActive) {
      return 'chevron down';
    } else {
      return 'chevron right';
    }
  }

  getIntermediateStops = () => {
    let output = [];
    const stops = this.props.section.intermediateStops;

    stops.forEach(stop => {
      const key = stop.departure.place.name;
      output.push(
        <Grid.Row key={key} style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
          <Grid.Column width={3}>
            <Image height='18px' src={intermediateStop} spaced='left' style={{ zIndex: 1 }} />
          </Grid.Column>
          <Grid.Column width={13} textAlign='left'>
            {stop.departure.place.name}
          </Grid.Column>
        </Grid.Row>
      );
    });

    return output;
  }


  getPublicTransportTypeIcon = () => {
    switch (this.getType()) {
      case 'S-Bahn':
        return sbahn;
      case 'U-Bahn':
        return ubahn;
      case 'Stadtbahn':
        return ubahn;
      case 'Bus':
        return bus;
      case 'NachtBus':
        return bus;
      case 'Tram':
        return tram;
      case 'Straßenbahn':
        return tram;
      case 'NachtTram':
        return tram;
      default:
        return '';
    }
  }

  setImageAnchor = () => {
    if(this.props.firstStation) {
      return <Image id={'entry' + this.props.index} height='18px' src={changeStop} spaced='left' style={{ zIndex: 1 }} />;
    } else {
      return <Image height='18px' src={changeStop} spaced='left' style={{ zIndex: 1 }} />;
    }
  }

  render() {
    let icon = this.getPublicTransportTypeIcon();
    let headsign = this.getHeadsign();
    let pointOfEntry = this.getPointOfEntry();
    let exitPoint = this.getExitPoint();
    let terminus = this.getTerminus();

    return (
      <>
        <Grid.Row style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
          <Grid.Column width={3}>
            {this.setImageAnchor()}
          </Grid.Column>
          <Grid.Column width={12} textAlign='left'>
            <Header size='small' content={pointOfEntry} />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
          <Grid.Column width={3} />
          <Grid.Column width={4} textAlign='left'>
            <Image src={icon} style={{ height: '20px' }} avatar />
            <span style={{ fontSize: '16px' }}>
              {headsign}
            </span>
          </Grid.Column>
          <Grid.Column width={8} textAlign='left'>
            {terminus}
          </Grid.Column>
        </Grid.Row>

        {
          (this.props.section.intermediateStops.length + 1) > 1 &&
          <Accordion fluid>
            <Accordion.Title
              active={this.state.stopsActive}
              onClick={() => { this.setState({ stopsActive: !this.state.stopsActive }) }}
            >
              <Grid container>
                <Grid.Row style={{ paddingTop: 0 }}>
                  <Grid.Column width={3} />
                  <Grid.Column width={12} textAlign='left'>
                    <div className='grey'>
                      {(this.props.section.intermediateStops.length + 1) + ' Haltestellen'}
                      <Icon link name={this.getDropdownIcon()} />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

            </Accordion.Title>
            <Accordion.Content active={this.state.stopsActive} style={{ paddingBottom: '1rem', paddingTop: '1rem' }}>
              <Grid container>
                {this.getIntermediateStops()}
              </Grid>
            </Accordion.Content>
          </Accordion>
        }

        {
          this.props.finalStation &&
          <Grid.Row style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
            <Grid.Column width={3}>
              <Image id={'exit' + this.props.index} height='18px' src={changeStop} spaced='left' style={{ zIndex: 1 }} />
            </Grid.Column>
            <Grid.Column width={12} textAlign='left'>
              <Header size='small' content={exitPoint} />
            </Grid.Column>
          </Grid.Row>
        }

        <Xarrow
          start={'parking' + this.props.index}
          end={'entry' + this.props.index}
          startAnchor='top' endAnchor='top'
          color='#656565'
          headSize={0}
          dashness={{ strokeLen: 4, nonStrokeLen: 8 }}
        />

        <Xarrow
          start={'entry' + this.props.index}
          end={'exit' + this.props.index}
          startAnchor='top' endAnchor='top'
          color='#656565'
          headSize={0}
        />

        <Xarrow
          start={'exit' + this.props.index}
          end={'destination' + this.props.index}
          startAnchor='top' endAnchor='top'
          color='#656565'
          headSize={0}
          dashness={{ strokeLen: 4, nonStrokeLen: 8 }}
        />
      </>
    );
  }
}

export default PublicTransportInformation